import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';


@Component({
  selector: 'app-pending-pay',
  templateUrl: './pending-pay.component.html',
  styleUrl: './pending-pay.component.css'
})


export class PendingPayComponent implements OnInit {
  pendingSpinner: boolean = false;
  pendingPay: any;
  totals: any;
  filteredPendingPay: any;
  searchText = '';
  associations: any[] = [];
  selectedUserId: string | null = null;
  ownerId: string | null = null;

  expandSet = new Set<number>();

  constructor(
    private data: DataserviceService
  ) {}

  ngOnInit(): void {
    this.getPendingPay()
  }

  onSearch() {
    const search = this.searchText.trim().toLowerCase();
  
    this.filteredPendingPay = this.pendingPay.filter((item: any) =>
      item.customer.toLowerCase().includes(search) ||
      item.rep.toLowerCase().includes(search) ||
      item.amount.toString().includes(search) ||
      item.groupedData.some((sub: any) => 
        sub.pay_type.toLowerCase().includes(search) || 
        (sub.note && sub.note.toLowerCase().includes(search))
      )
    );
  }

  getPendingPay(userId?: string) {
    this.pendingSpinner = true;
    const params: any = {};
    if (userId) {
      params.userId = userId;
    }
    this.data.getData('pending-pay-import/pending', { params })
      .subscribe({
        next: (res: any) => {
          this.pendingPay = res?.data;
          this.filteredPendingPay = this.pendingPay;
          this.totals = res?.summary;
          this.associations = Array.isArray(res?.associations) ? res.associations : [];
          this.ownerId = res?.owner_id || null;
          this.selectedUserId = res?.selected_user_id || this.ownerId;
          this.pendingSpinner = false;
        },
        error: () => {
          this.pendingSpinner = false;
        }
      })
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  trackById(index: number, item: any): any {
    return item?.work_order_id || item?.id || index;
  }

  downloadPending() {
    const params: any = {};
    if (this.selectedUserId) {
      params.userId = this.selectedUserId;
    }
    this.data.getData('pending-pay-import/download', { params })
      .subscribe({
        next: (res: any) => {
          this.generateCsv(res)
        }
      })
  }

  onUserChange(userId: string) {
    this.getPendingPay(userId);
  }

  generateCsv(data: any) {
    const csv = this.convertToCSV(data);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    
    const a = document.createElement('a');
    a.href = url;
    a.download = 'knockvia-customers.csv';
    a.click();
  }

  convertToCSV(data: any) {
    const header = Object.keys(data[0]).join(',') + '\n';
    const rows = data.map((row: any) => Object.values(row).join(',')).join('\n');
    return header + rows;
  }

  asNumber(value: any): number {
    if(value) {
      const coerced = Number(value);
      return Number.isFinite(coerced) ? coerced : 0;
    }else {
      return 0
    }
  }

}
